export default "__VITE_PUBLIC_ASSET__21abc5e5__"